import React from 'react';
import { useSelector } from 'react-redux';
import {
    Switch,
    Redirect
  } from 'react-router-dom';

import { PublicRoute } from './PublicRoute';
import { PrivateRoute } from './PrivateRoute';

import { LoginScreen } from '../components/auth/LoginScreen';
import { RegisterScreen } from '../components/auth/RegisterScreen';
import { MainScreen } from '../components/views/MainScreen';
import { PreviousProgramScreen } from '../components/views/PreviousProgramScreen';
import { DetailPreviousProgramScreen } from '../components/views/DetailPreviousProgramScreen';
import { ContentMarketingScreen } from '../components/views/ContentMarketingScreen';
import { CreateContentMarketingScreen } from '../components/views/CreateContentMarketingScreen';
import {ContentMarketingSectionScreen} from '../components/views/ContentMarketingSectionScreen';
import { AdvancePaymentScreen } from '../components/views/AdvancePaymentScreen';
import { AdvancedPaymentScreenSuccess } from '../components/views/AdvancedPaymentScreenSuccess';
import { AdvancedPaymentScreenFailure } from '../components/views/AdvancedPaymentScreenFailure';
import { PaymentScreen } from '../components/views/PaymentScreen';
import { SaleOrderScreen } from '../components/views/SaleOrderScreen';
import { PaymentScreenSuccess } from '../components/views/PaymentScreenSuccess';
import { PaymentScreenFailure } from '../components/views/PaymentScreenFailure';
import { ConfirmRegisterScreen } from '../components/auth/ConfirmRegisterScreen';
import { AccountScreen } from '../components/views/AccountScreen';
import { DetailPaymentScreen } from '../components/views/DetailPaymentScreen';
import { GroupsScreen } from '../components/views/GroupsScreen';
import { CreateGroupScreen } from '../components/views/CreateGroupScreen';
import { UsersScreen } from '../components/views/UsersScreen';
import { CreateCustomerScreen } from '../components/views/CreateCustomerScreen';
import { validateAccessUser } from '../constants/component/validateAccessUser.js';
import * as view from '../constants/models/viewsList';
import { ADMINISTRADOR, ADMINISTRADOR_ZONA, EMPLEADO, SYSTEM } from '../constants/models/typeOperationRol';
import { BillingStatementScreen } from '../components/views/BillingStatementScreen.js';
import { DiscountsAndInvoicesHeaderScreen } from '../components/views/DiscountsAndInvoicesHeaderScreen.js';
import { DiscountsAndInvoicesDetailScreen } from '../components/views/DiscountsAndInvoicesDetailScreen.js';
import { DetailAdvancePaymentScreen } from '../components/views/DetailAdvancePaymentScreen.js';
import { AdvanceAndInvoiceScreen } from '../components/views/AdvanceAndInvoiceScreen.js';
import { ConfigUserAdminZoneScreen } from '../components/views/ConfigUserAdminZoneScreen.js';
import { AdvancesInvoicesAndComplementsScreen } from '../components/views/AdvancesInvoicesAndComplementsScreen.js';
import { AdvancesInvoicesAndComplementsDetailScreen } from '../components/views/AdvancesInvoicesAndComplementsDetailScreen.js';
import { DiscountsAndInvoicesDetailOriginScreen } from '../components/views/DiscountsAndInvoicesDetailOriginScreen.js';
import { TermsAndConditionsScreen } from '../components/views/TermsAndConditionsScreen.js';
import { CreateTermsAndConditionsScreen } from '../components/views/CreateTermsAndConditionsScreen.js';
import ImageAdministrationScreen from '../components/views/ImageAdministrationScreen.js';
import {ContentVideoScreen} from '../components/views/ContentVideoScreen.js';
import { CreateImageScreen } from '../components/views/CreateImageScreen.js';
import { CreateVideoScreen } from '../components/views/CreateVideoScreen.js';

export const AppRouter = () => {

    const { isLoggedIn, user } = useSelector( state => state.auth);
    
    const operationRol = isLoggedIn? user.operationRol:'---';
    return (
            <>
                <Switch>

                    <PublicRoute
                        exact
                        path="/auth/"
                        component={ LoginScreen }
                    />

                    <PublicRoute
                        exact
                        path="/auth/register"
                        component={ RegisterScreen }
                    />

                    <PublicRoute
                        exact
                        path="/auth/register/confirmation/:id"
                        component={ ConfirmRegisterScreen }
                    />

                    <PrivateRoute
                        exact
                        path="/"
                        
                        component={ MainScreen }
                        permission={true}
                    />

                    <PrivateRoute
                        exact
                        path="/operation/previous-program"
                        component={ PreviousProgramScreen }
                        permission={validateAccessUser(view.VIEW_PREVIOUS_PROGRAM, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/detail-previous-program"
                        component={ DetailPreviousProgramScreen }
                        permission={validateAccessUser(view.VIEW_PREVIOUS_PROGRAM_DETAIL, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/payment"
                        component={ PaymentScreen }
                        permission={validateAccessUser(view.VIEW_PAYMENT, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/payment/success"
                        component={ PaymentScreenSuccess }
                        permission={validateAccessUser(view.VIEW_PAYMENT, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/payment/failure"
                        component={ PaymentScreenFailure }
                        permission={validateAccessUser(view.VIEW_PAYMENT, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/detail-payment"
                        component={ DetailPaymentScreen }
                        permission={validateAccessUser(view.VIEW_PAYMENT_DETAIL, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/detail-advance-payment"
                        component={ DetailAdvancePaymentScreen }
                        permission={validateAccessUser(view.VIEW_ANTICIPATION_PAYMENT, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/sale-order"
                        component={ SaleOrderScreen }
                        permission={validateAccessUser(view.VIEW_SALE_ORDER, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/advance-payment"
                        component={ AdvancePaymentScreen }
                        permission={validateAccessUser(view.VIEW_ADVANCE_PAYMENT, user) && operationRol !== ADMINISTRADOR_ZONA}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/billing-statement"
                        component={BillingStatementScreen}
                        permission={validateAccessUser(view.BILLING_STATEMENT, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/discounts-and-invoices/header"
                        component={DiscountsAndInvoicesHeaderScreen}
                        permission={validateAccessUser(view.VIEW_DISCOUNT_AND_INVOINCE, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/discounts-and-invoices/detail-aplication/:id"
                        component={DiscountsAndInvoicesDetailScreen}
                        permission={validateAccessUser(view.VIEW_DISCOUNT_AND_INVOINCE, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/discounts-and-invoices/detail-origin/:id"
                        component={DiscountsAndInvoicesDetailOriginScreen}
                        permission={validateAccessUser(view.VIEW_DISCOUNT_AND_INVOINCE, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/advance-and-invoices"
                        component={AdvanceAndInvoiceScreen}
                        permission={validateAccessUser(view.VIEW_MANAGEMENT_ADVANCES_INVOICES, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/advances-invoices-and-complements"
                        component={AdvancesInvoicesAndComplementsScreen}
                        permission={true}
                    />
                    <PrivateRoute
                        exact
                        path="/operation/advances-invoices-and-complements/detail/:id"
                        component={AdvancesInvoicesAndComplementsDetailScreen}
                        permission={true}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/content/advance-payment/success"
                        component={ AdvancedPaymentScreenSuccess }
                        permission={validateAccessUser(view.VIEW_ADVANCE_PAYMENT, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/content/advance-payment/failure"
                        component={ AdvancedPaymentScreenFailure }
                        permission={validateAccessUser(view.VIEW_ADVANCE_PAYMENT, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/admin-zone"
                        component={ ConfigUserAdminZoneScreen }
                        permission={validateAccessUser(view.VIEW_ZONE_ADMIN, user) && operationRol === ADMINISTRADOR_ZONA}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/groups"
                        component={ GroupsScreen }
                        permission={validateAccessUser(view.VIEW_GROUP, user) && operationRol !== EMPLEADO && operationRol !== ADMINISTRADOR_ZONA}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/groups/create"
                        component={ CreateGroupScreen }
                        permission={validateAccessUser(view.CREATE_GROUP, user) && operationRol === ADMINISTRADOR}
                    />
                    <PrivateRoute
                        path="/administration/groups/update/:id"
                        component={ CreateGroupScreen }
                        permission={validateAccessUser(view.CREATE_GROUP, user) && operationRol !== EMPLEADO && operationRol !== ADMINISTRADOR_ZONA}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/terms-and-conditions"
                        component={ TermsAndConditionsScreen}
                        permission={validateAccessUser(view.VIEW_TERMS_AND_CONDITIONS, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/terms-and-conditions/create"
                        component={ CreateTermsAndConditionsScreen }
                        permission={validateAccessUser(view.UPLOAD_TERMS_AND_CONDITIONS, user)  && operationRol === SYSTEM}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/image-list"
                        component={ ImageAdministrationScreen }
                        permission={validateAccessUser(view.VIEW_SLIDER, user)  && operationRol === SYSTEM}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/image-list/create"
                        component={ CreateImageScreen }
                        permission={validateAccessUser(view.VIEW_SLIDER, user)  && operationRol === SYSTEM}
                    />
                     <PrivateRoute
                        exact
                        path="/administration/content/video"
                        component={ ContentVideoScreen }
                        permission={validateAccessUser(view.VIEW_CONTENT, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/content/video/create"
                        component={ CreateVideoScreen }
                        permission={validateAccessUser(view.CREATE_CONTENT, user)  && operationRol === SYSTEM}
                    />
                    <PrivateRoute
                        path="/administration/content/video/update/:id"
                        component={ CreateVideoScreen }
                        permission={validateAccessUser(view.CREATE_CONTENT, user)  && operationRol === SYSTEM}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/users"
                        component={ UsersScreen }
                        permission={validateAccessUser(view.VIEW_USER, user) && operationRol !== EMPLEADO && operationRol !== ADMINISTRADOR_ZONA}
                    />
                    <PrivateRoute
                        path="/administration/users/create"
                        component={ CreateCustomerScreen }
                        permission={validateAccessUser(view.UPDATE_USER, user) && operationRol === ADMINISTRADOR}
                    />
                    <PrivateRoute
                        path="/administration/users/update/:id"
                        component={ CreateCustomerScreen }
                        permission={validateAccessUser(view.UPDATE_USER, user) && operationRol === ADMINISTRADOR}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/content/marketing"
                        component={ ContentMarketingScreen }
                        permission={validateAccessUser(view.VIEW_CONTENT, user)}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/content/marketing/section"
                        component={ ContentMarketingSectionScreen }
                        permission={validateAccessUser(view.VIEW_CONTENT, user) && operationRol === SYSTEM}
                    />
                    <PrivateRoute
                        exact
                        path="/administration/content/marketing/create"
                        component={ CreateContentMarketingScreen }
                        permission={validateAccessUser(view.CREATE_CONTENT, user)  && operationRol === SYSTEM}
                    />
                    <PrivateRoute
                        path="/administration/content/marketing/update/:id"
                        component={ CreateContentMarketingScreen }
                        permission={validateAccessUser(view.CREATE_CONTENT, user)  && operationRol === SYSTEM}
                    />
                    <PrivateRoute
                        exact
                        path="/configuration/account"
                        component={ AccountScreen}
                        permission={validateAccessUser(view.UPDATE_PASS, user)}
                    />

                    

                    <Redirect to="/auth/" />   
                    
                    
                </Switch>
            </>
    )
}